<div class="gesuch-modul">
    <h1 class="access-for-all-title" translate>AFA_GESUCHSFORMULAR</h1>
    <div class="row view-title">
        <div class="col-md-12">
            <h2>
                <span
                    translate
                    [translateParams]="{antragstellende: getGSName()}"
                    >EKVI_EINKOMMENSVERSCHLECHTERUNG_FUER_BASISJAHR</span
                >
            </h2>
            <hr class="header" />
        </div>
    </div>

    @if (
        model.finanzielleSituationTyp === 'SCHWYZ_ERWEITERT' &&
        !model.getFiSiConToWorkWith().finanzielleSituationJA.quellenbesteuert
    ) {
        <div class="row margin-bottom-3rem">
            <div class="col-md-12">
                <span
                    [innerHTML]="
                        'EINKOMMENSVERSCHLECHTERUNG_PRE_TEXT' | translate
                    "
                ></span>
            </div>
        </div>
    }

    @if (isFinSitVollstaendigAusgefuellt) {
        <form #form="ngForm">
            @if (
                model.getFiSiConToWorkWith().finanzielleSituationJA
                    .quellenbesteuert
            ) {
                <dv-bruttolohn-schwyz
                    [finSitJA]="model.getEkvToWorkWith()"
                    [finSitGS]="model.getEkvToWorkWith_GS()"
                    [readonly]="gesuchmodelManager.isGesuchReadonly()"
                    (valueChanged)="recalculatedMassgebendesEinkommen()"
                >
                </dv-bruttolohn-schwyz>
            } @else {
                <dv-steuerveranlagt-schwyz
                    [finSitJA]="model.getEkvToWorkWith()"
                    [finSitGS]="model.getEkvToWorkWith_GS()"
                    [readonly]="gesuchmodelManager.isGesuchReadonly()"
                    [showHeader]="false"
                    [schwyzErweiterteFinSit]="
                        isSchwyzFinSitTypSchwyzErweitert()
                    "
                    [ekvMode]="true"
                    (valueChanged)="recalculatedMassgebendesEinkommen()"
                >
                </dv-steuerveranlagt-schwyz>
            }
        </form>
        <dv-navigation-x
            (dvSave)="prepareSave($event.onResult)"
            [canGoNext]="true"
            [canGoPrevious]="true"
            [dvSubStep]="3"
        ></dv-navigation-x>
    } @else {
        <div
            data-test="warnung-ekv-fin-sit-ausfuellen"
            class="well well-status-warten"
        >
            <span translate>WARNUNG_FIN_SIT_AUSFUELLEN</span>
        </div>
    }
</div>
